import React from 'react'
import PropTypes from 'prop-types'
import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { getInitials } from 'lib/text-display'
import { useStyles } from './styles'

// `variant="card"` is the "Your coach" panel on the checkout; `"member"` is the
// same facts without a panel, in the My Coach card's avatar and name style, for
// the member shell pages; the default is the compact "with <name>" line.
const CoachLine = ({ coach, prefix, variant }) => {
  const classes = useStyles()
  if (!coach?.name) return null

  const avatar = (
    <Avatar
      className={
        variant === 'card' ? classes.coachCardAvatar : classes.coachAvatar
      }
      alt=""
      src={coach.coachProfile?.profilePhoto || undefined}
    >
      {getInitials(coach.name)}
    </Avatar>
  )

  if (variant === 'member') {
    return (
      <Box className={classes.memberCoach}>
        <Avatar
          className={classes.memberCoachAvatar}
          alt=""
          src={coach.coachProfile?.profilePhoto || undefined}
        >
          {getInitials(coach.name)}
        </Avatar>
        <Box minWidth={0}>
          <Typography component="p" className={classes.memberCoachLabel}>
            Your coach
          </Typography>
          <Typography component="p" className={classes.memberCoachName}>
            {coach.name}
          </Typography>
          {coach.coachProfile?.title ? (
            <Typography component="p" className={classes.memberCoachLabel}>
              {coach.coachProfile.title}
            </Typography>
          ) : null}
        </Box>
      </Box>
    )
  }

  if (variant === 'card') {
    return (
      <Box className={classes.coachCard}>
        {avatar}
        <Box minWidth={0}>
          <Typography component="p" className={classes.coachCardLabel}>
            Your coach
          </Typography>
          <Typography component="p" className={classes.coachCardName}>
            {coach.name}
          </Typography>
          {coach.coachProfile?.title ? (
            <Typography component="p" className={classes.coachCardLabel}>
              {coach.coachProfile.title}
            </Typography>
          ) : null}
        </Box>
      </Box>
    )
  }

  return (
    <Box className={classes.metaRow}>
      {avatar}
      <Typography variant="body2" component="span">
        {prefix}
        {coach.name}
      </Typography>
    </Box>
  )
}

CoachLine.propTypes = {
  coach: PropTypes.shape({
    name: PropTypes.string,
    coachProfile: PropTypes.shape({
      profilePhoto: PropTypes.string,
      title: PropTypes.string,
    }),
  }),
  prefix: PropTypes.string,
  variant: PropTypes.oneOf(['inline', 'card', 'member']),
}

CoachLine.defaultProps = { variant: 'inline' }

export default CoachLine
